module.exports = __webpack_public_path__ + "img/single.7fae7472.svg";